import { useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "@routes/routePath";

interface Args {
  draftArticleId: string;
  labelId: string;
}

export const useMoveRegulatoryDetailPage = ({
  draftArticleId,
  labelId,
}: Args) => {
  const navigate = useNavigate();

  const moveRegulatoryDetailPage = () => {
    const pathname = ROUTE_PATHS.regulatoryFillInTable;
    const url = `${pathname}?id=${draftArticleId}&labelId=${labelId}`;

    navigate(url);
  };

  return {
    moveRegulatoryDetailPage,
  };
};
